import "firebase/messaging";

import * as firebase from "firebase/app";

let messaging;

if (firebase.messaging.isSupported()) {
	if (
		localStorage.getItem("firebasePublic") !== "null" &&
		localStorage.getItem("firebaseSenderId") !== "null" &&
		localStorage.getItem("firebasePublic") !== null &&
		localStorage.getItem("firebaseSenderId") !== null
	) {
		const initializedFirebaseApp = firebase.initializeApp({
			messagingSenderId: localStorage.getItem("firebaseSenderId"),
		});
		messaging = initializedFirebaseApp.messaging();
		messaging.usePublicVapidKey(localStorage.getItem("firebasePublic"));
	} else {
		const initializedFirebaseApp = firebase.initializeApp({
			messagingSenderId: "652893313820",
		});
		messaging = initializedFirebaseApp.messaging();
		messaging.usePublicVapidKey(
			"BJoKHyd7pJk_7iUIQxnsOdISBREXwvwS-v6QOO9DGmMPqnDEFBQcVmgkwVnql9QOV32f5nfzgO-t-bG63WKgPVo"
		);
	}
}
export default messaging;
